import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.hr.attendance');
import { Input, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-hr-attendance',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.hr.attendance/view.scss */
:host {
  display: block;
  width: 100%;
  height: 100%;
}`],
})
export class PortalLpsysadminHrAttendanceComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() selfOnly: boolean = false;

    public loaded: boolean = false;
    public canManageAll: boolean = false;
    public users: any[] = [];
    public selectedUserId: string = '';
    public selectedUser: any = {};
    public selectedCompany: string = '';
    public companyOptions: any[] = [];
    public currentUserId: string = '';
    public month: string = new Date().toISOString().slice(0, 7);
    public today: any = {};
    public records: any[] = [];
    public team: any[] = [];
    public summary: any = {};
    public week: any = {};
    public legal: any[] = [];
    public workForm: any = { work_type: 'office', location: '', memo: '', break_minutes: 60 };
    public edit: any = null;

    public statusMap: any = {
        scheduled: '예정',
        working: '근무중',
        closed: '퇴근완료',
        leave: '휴가',
        holiday: '휴일',
    };

    public workTypeMap: any = {
        office: '사무실',
        remote: '재택',
        outside: '외근',
        business_trip: '출장',
    };

    public async ngOnInit() {
        await this.service.init();
        if (!this.selfOnly && !this.isSuperAdmin()) {
            this.service.href('/admin/system/my-attendance');
            return;
        }
        await this.load();
    }

    public async load() {
        this.loaded = false;
        await this.service.render();
        const { code, data } = await wiz.call("load", {
            user_id: this.selfOnly ? '' : this.selectedUserId,
            month: this.month,
            company_name: this.selfOnly ? '' : this.selectedCompany,
            self_only: this.selfOnly ? '1' : '',
        });
        if (code === 200) {
            this.canManageAll = !!data.can_manage_all;
            this.users = data.users || [];
            this.selectedUserId = data.selected_user_id || '';
            this.selectedUser = data.selected_user || {};
            this.selectedCompany = data.selected_company || this.selectedCompany;
            this.companyOptions = data.company_options || [];
            this.currentUserId = data.current_user_id || '';
            this.today = data.today || {};
            this.records = data.records || [];
            this.team = data.team || [];
            this.summary = data.summary || {};
            this.week = data.week || {};
            this.legal = data.legal || [];
        } else {
            this.service.alert.error(data?.message || "근태 정보를 불러오지 못했습니다.");
        }
        this.loaded = true;
        await this.service.render();
    }

    public async applyCompanyFilter() {
        if (this.selfOnly) return;
        this.selectedUserId = '';
        this.edit = null;
        await this.load();
    }

    public async clockIn() {
        const res = await wiz.call("clock_in", {
            user_id: this.selfOnly ? '' : this.selectedUserId,
            work_type: this.workForm.work_type,
            location: this.workForm.location,
            memo: this.workForm.memo,
            self_only: this.selfOnly ? '1' : '',
        });
        if (res.code === 200) {
            this.service.alert.success("출근 처리되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "출근 처리에 실패했습니다.");
        }
    }

    public async clockOut() {
        const res = await wiz.call("clock_out", {
            user_id: this.selfOnly ? '' : this.selectedUserId,
            break_minutes: this.workForm.break_minutes,
            memo: this.workForm.memo,
            self_only: this.selfOnly ? '1' : '',
        });
        if (res.code === 200) {
            this.service.alert.success("퇴근 처리되었습니다.");
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "퇴근 처리에 실패했습니다.");
        }
    }

    public openEdit(row: any = null) {
        const base = row ? { ...row } : {
            id: '',
            user_id: this.selectedUserId,
            work_date: new Date().toISOString().slice(0, 10),
            check_in_at: '',
            check_out_at: '',
            break_minutes: 60,
            work_type: 'office',
            location: '',
            memo: '',
            correction_reason: '',
        };
        if (base.check_in_at) base.check_in_at = base.check_in_at.replace(' ', 'T');
        if (base.check_out_at) base.check_out_at = base.check_out_at.replace(' ', 'T');
        this.edit = base;
        this.service.render();
    }

    public closeEdit() {
        this.edit = null;
        this.service.render();
    }

    public async saveEdit() {
        const res = await wiz.call("save_record", {
            ...(this.edit || {}),
            user_id: this.selfOnly ? '' : this.edit?.user_id,
            self_only: this.selfOnly ? '1' : '',
        });
        if (res.code === 200) {
            this.service.alert.success("근태 기록이 저장되었습니다.");
            this.edit = null;
            await this.load();
        } else {
            this.service.alert.error(res.data?.message || "저장에 실패했습니다.");
        }
    }

    public minutes(value: number): string {
        const min = Number(value || 0);
        const h = Math.floor(min / 60);
        const m = min % 60;
        if (h <= 0) return `${m}분`;
        if (m === 0) return `${h}시간`;
        return `${h}시간 ${m}분`;
    }

    public statusClass(status: string): string {
        const map: any = {
            scheduled: 'bg-zinc-100 text-zinc-600',
            working: 'bg-emerald-100 text-emerald-700',
            closed: 'bg-blue-100 text-blue-700',
            leave: 'bg-violet-100 text-violet-700',
            holiday: 'bg-amber-100 text-amber-700',
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public flagClass(level: string): string {
        if (level === 'risk') return 'bg-red-50 text-red-700 border-red-100';
        if (level === 'warn') return 'bg-amber-50 text-amber-700 border-amber-100';
        return 'bg-blue-50 text-blue-700 border-blue-100';
    }

    public isSuperAdmin(): boolean {
        return this.service.auth?.session?.membership === 'super_admin';
    }

    public pageTitle(): string {
        return this.selfOnly ? '내 근태관리' : '근태관리';
    }

    public pageDescription(): string {
        return this.selfOnly ? '내 출퇴근, 휴게, 연장·야간·휴일근로 리스크를 월 단위로 확인합니다.' : '출퇴근, 휴게, 연장·야간·휴일근로 리스크를 월 단위로 관리합니다.';
    }
}

export default PortalLpsysadminHrAttendanceComponent;